import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    maxWidth: '854px',
    width: '100%',
    margin: '1em auto 4em',
    padding: '15px'
  }
})
